import React from "react";
import parse from "html-react-parser";

const TableTd = ({td}) => {
    const keys = Object.keys(td);
    const title = (td?.title) ? parse(String(td?.title)) : '';
    const width = keys.includes('width') ? td['width'] : '';
    const col = keys.includes('col') ? td['col'] : '1';

    return (
        <td scope="col"
            width={width}
            colSpan={col}
            className={td['class']}
        >
            {title}
        </td>
    )
}

export default TableTd;
